// extracted by mini-css-extract-plugin
export default {"title":"AddPost_title__R3FDF","subtitle":"AddPost_subtitle__eHifG","image":"AddPost_image__1nXDh","buttons":"AddPost_buttons__5k6HE"};